import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

/**
 * Helper to construct URL path segment for role-scoped endpoints. Only SHIPPER and CARRIER expose
 * these resources; other roles (ADMINISTRATOR, BRANCH_ADMINISTRATOR) have none.
 */
function getRolePathSegmentOrNull(roleType: RoleValue): string | null {
  switch (roleType) {
    case "SHIPPER":
      return "shippers";
    case "CARRIER":
      return "carriers";
    default:
      return null;
  }
}

export function useShipmentQuotes(shipmentId: number | undefined) {
  const { role } = useRoleContext();

  const rolePathSegment = role ? getRolePathSegmentOrNull(role.type) : null;

  const url =
    shipmentId && role && rolePathSegment
      ? `/${rolePathSegment}/${role.id}/shipments/${shipmentId}/quotes`
      : null;

  const { data, loading, error, refetch } = useSwrFetch<CondensedQuote[]>({
    url,
    errorMessage: "Failed to fetch quotes",
    errorMessageKey: "message",
  });

  return {
    quotes: data ?? [],
    isLoading: loading,
    error,
    refetchQuotes: refetch,
  };
}
